<template>
  <div
    class="modal"
    :class="value ? 'show' : 'hide'"
    :style="
      value ? 'display:block;background-color:#3333337a;' : 'display:none;'
    "
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-scrollable" role="document">
      <div class="modal-content" :style="'width:' + width">
        <div class="modal-header">
          <h3 class="">{{ title }}</h3>
        </div>
        <div class="modal-body">
          <div class="row modal-padding">
            <div class="col-md-12 d-flex flex-row flex-wrap">
              <div
                class="pb"
                :class="getColor(item)"
                v-for="(item, i) in items"
                :key="i"
                @click="selectItem(item)"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-mouveal" @click="cancelWin">Annuler</button>
          <button class="btn btn-mouveal" @click="saveWin">Ajouter</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mconfirmdialog",
  components: {},
  props: {
    items: Array,
    itemsOk: Array,
    value: {
      default: false,
      type: Boolean
    },
    title: String,
    width: String
  },
  data() {
    return {
      dialog: false,
      dataItemsOk: []
    };
  },
  mounted() {
    this.dataItemsOk = this.itemsOk;
  },
  watch: {
    itemsOk(tab) {
      // console.log(
      //   "this.dataItemsOk = this.itemsOk;",
      //   this.dataItemsOk,
      //   this.itemsOk
      // );
      this.dataItemsOk = this.itemsOk;
    }
  },
  computed: {},
  methods: {
    getColor(item) {
      let color = " bg-gray";
      let f = this.dataItemsOk.find(element => element === item);
      if (f) color = " bg-green";
      return color;
    },
    selectItem(item) {
      let i = this.dataItemsOk.findIndex(element => element === item);
      if (i >= 0) {
        this.dataItemsOk.splice(i, 1);
      } else {
        this.dataItemsOk.push(item);
      }
    },
    cancelWin() {
      this.$emit("canceled");
    },
    saveWin() {
      this.$emit("addTag", this.dataItemsOk);
    }
  }
};
</script>
<style lang="scss" scoped>
.pb {
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-left: 8px;
  margin-bottom: 8px;
  cursor: pointer;
}
.bg-gray {
  background-color: #1b9dd7;
}
.bg-green {
  background-color: #52c131;
}
.modal-content {
  margin: auto;
}
</style>
